import LabtestOrderReport from "./LabtestOrderReport";

const LabtestReport = () => {
    return (
        <div>
            <LabtestOrderReport/>
        </div>
    );
};

export default LabtestReport;